import { Component, OnInit } from '@angular/core';

import { MetaService } from '../meta.service';
import { Project } from '../project/project.model';
import { ProjectService } from '../project/project.service';
import { ScrollService } from '../scroll.service';

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.min.css'],
})
export class HomeComponent implements OnInit {
    public projects: Array<Project>;
    public projectsLoaded = false;

    private projectSlugs: Array<string> = [
    ];

    public constructor(private metaService: MetaService,
                       private projectService: ProjectService,
                       public scrollService: ScrollService) {
    }

    public ngOnInit(): void {
        this.metaService.updateMetaSettings({
            pageTitle: 'Home',
            title: 'Home',
        });
        Promise.all(this.projectSlugs.map(s => this.projectService.getProjectBySlug(s)))
            .then(projects => {
                this.projects = projects;
                this.projectsLoaded = true;
            });
    }
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/home/home.component.ts